module.exports = __webpack_public_path__ + "static/media/icons.b87b9ba5.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styling/theme/assets/fonts/icons.ttf
// module id = ./src/styling/theme/assets/fonts/icons.ttf
// module chunks = 0